module.exports = "<div class=\"alert alert-warning\"><% print(text); %></div>"